import SortMenu from "./SortMenu";

export default SortMenu;
